/** @jsxImportSource @emotion/react */

import { FormControl, MenuItem, Select } from "@mui/material";

import css from "../form.module.css";

const CustomSelect = ({
  label,
  value,
  variant = "outlined",
  options = [],
  onChange,
  halfWidth,
  selectedColor,
  ...rest
}) => {
  const existingVal = !!options.find(opt => opt.id === value)
    ? value
    : '';

  return (
    <FormControl
      css={emotion.formControl(halfWidth)}
      className={css.field}
    >
      {label && <label>{label}</label>}

      <Select
        value={existingVal}
        variant={variant}
        onChange={onChange}
        {...rest}
        css={emotion.select(selectedColor)}
        className={css.select}
      >
        {options.map((opt) => (
          <MenuItem key={opt.id} value={opt.id} disabled={opt.disabled} sx={opt.sx}>
            {opt.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

const emotion = {
  formControl: (isHalfWidth) => ({
    flex: isHalfWidth ? '0 1 48.5%' : null,
    width: isHalfWidth ? 'auto' : '100%',
  }),

  select: (selectedColor) => ({
    ...(selectedColor ? {color: selectedColor} : {}),
  }),
};

export default CustomSelect;
